import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TeamActionMockSettingsService } from '../../team-action-mock-settings.service';
import { TeamActionMockTeamsStore } from '../../team-action-mock-teams.store';
import { openTeamForm } from '../team-form-modal/team-action-mock-team-form-modal.component';
import {
  establishmentNames,
  memberIssue,
  MOCK_TEAMS,
  MockPerson,
  MockTeam,
  personInitials,
} from '../../team-action-mock.data';
import {
  TeamActionMockTeamMemberRemovalModalComponent,
  TeamMemberModalData,
} from '../team-member-removal-modal/team-action-mock-team-member-removal-modal.component';
import { TeamActionMockTeamMemberAddModalComponent } from '../team-member-add-modal/team-action-mock-team-member-add-modal.component';

interface MemberRow {
  member: MockPerson;
  initials: string;
  establishments: string;
  issue: string | null;
}

// Maquette d'estimation « action d'équipe » : fiche d'une équipe, périmètre déduit, membres et désignations.
@Component({
  selector: 'team-action-mock-team-details-screen',
  templateUrl: './team-action-mock-team-details-screen.component.html',
})
export class TeamActionMockTeamDetailsScreenComponent implements OnInit, OnChanges {
  @Input() team: MockTeam = MOCK_TEAMS.validators;

  readonly displayedColumns = ['establishment', 'scope', 'designation'];
  members: MemberRow[] = [];

  constructor(
    public settings: TeamActionMockSettingsService,
    private dialog: MatDialog,
    private store: TeamActionMockTeamsStore,
  ) {}

  // Sans [team], ngOnChanges n'est pas appelé : la page de la maquette passe par ngOnInit.
  ngOnInit(): void {
    this.buildMembers();
  }

  ngOnChanges(): void {
    this.buildMembers();
  }

  private buildMembers(): void {
    this.members = this.team.members.map(member => ({
      member,
      initials: personInitials(member),
      establishments: establishmentNames(member.establishments),
      issue: memberIssue(member, this.team),
    }));
  }

  edit(): void {
    openTeamForm(this.dialog, this.store, { team: this.team }).subscribe(team => team && this.buildMembers());
  }

  openAdd(): void {
    this.dialog.open(TeamActionMockTeamMemberAddModalComponent, { width: '640px', data: { team: this.team } });
  }

  openRemoval(member: MockPerson): void {
    const data: TeamMemberModalData = { team: this.team, member };
    this.dialog.open(TeamActionMockTeamMemberRemovalModalComponent, { width: '600px', data });
  }
}
